module.exports = __webpack_public_path__ + "img/photo1.6e04a92c.png";